import { create } from 'zustand';
import type { Project, Server, Component, Alert } from './types';

interface OpsState {
  currentProject: Project | null;
  projects: Project[];
  servers: Server[];
  components: Component[];
  alerts: Alert[];
  sidebarOpen: boolean;
}

interface OpsActions {
  setCurrentProject: (project: Project | null) => void;
  setProjects: (projects: Project[]) => void;
  setServers: (servers: Server[]) => void;
  setComponents: (components: Component[]) => void;
  setAlerts: (alerts: Alert[]) => void;
  toggleSidebar: () => void;
}

export const useOpsStore = create<OpsState & OpsActions>((set) => ({
  currentProject: null,
  projects: [],
  servers: [],
  components: [],
  alerts: [],
  sidebarOpen: true,

  setCurrentProject: (project) => set({ currentProject: project }),
  setProjects: (projects) => set({ projects }),
  setServers: (servers) => set({ servers }),
  setComponents: (components) => set({ components }),
  setAlerts: (alerts) => set({ alerts }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
}));
